import React, { useState } from 'react';
import Icons from './Icons';

const contactHighlights = [
	{
		icon: <Icons.MapPin />,
		title: 'Ubicacion de la empresa',
		description: 'Integramos un mapa en tiempo real para que tus visitas, recojos y coordinaciones sean mas simples.',
	},
	{
		icon: <Icons.Clock />,
		title: 'Respuesta comercial agil',
		description: 'Recibimos solicitudes de compra, venta, muestreo y analisis desde un solo formulario.',
	},
	{
		icon: <Icons.Shield />,
		title: 'Atencion profesional',
		description: 'Nuestro equipo coordina operaciones con enfoque tecnico, trazabilidad y seguimiento continuo.',
	},
];

export default function Contact() {
	const [submitted, setSubmitted] = useState(false);

	const handleSubmit = (event) => {
		event.preventDefault();
		setSubmitted(true);
		window.setTimeout(() => setSubmitted(false), 3000);
		event.target.reset();
	};

	return (
		<section id="contacto" className="relative overflow-hidden bg-slate-950 py-20 text-white">
			<div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(20,184,166,0.18),_transparent_32%),radial-gradient(circle_at_bottom_right,_rgba(250,204,21,0.14),_transparent_28%)]" />

			<div className="relative mx-auto max-w-7xl px-4">
				<div className="max-w-3xl">
					<span className="glass inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-mineral-100">
						<Icons.Mail />
						Contacto y ubicacion
					</span>
					<h2 className="mt-5 text-3xl font-bold sm:text-4xl">Conversemos sobre tu operacion minera</h2>
					<p className="mt-4 text-lg text-slate-300">
						Te ayudamos a coordinar compras, ventas, analisis y visitas tecnicas desde una sola seccion,
						con una experiencia mas clara y un mapa integrado para ubicar la empresa facilmente.
					</p>
				</div>

				<div className="mt-12 grid gap-8 lg:grid-cols-[0.82fr_1.18fr]">
					<div className="space-y-6">
						<div className="glass rounded-[32px] p-6 shadow-2xl shadow-slate-950/30">
							<h3 className="text-2xl font-semibold">Punto de contacto centralizado</h3>
							<p className="mt-3 text-slate-300">
								Comparte tu requerimiento y coordinamos la siguiente accion: cotizacion, muestreo,
								despacho, reunion comercial o visita a planta.
							</p>

							<div className="mt-6 space-y-4">
								{contactHighlights.map((item) => (
									<div
										key={item.title}
										className="rounded-2xl border border-white/10 bg-white/5 p-4 transition hover:bg-white/10"
									>
										<div className="flex items-start gap-4">
											<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-mineral-400/15 text-mineral-200">
												{item.icon}
											</div>
											<div>
												<h4 className="text-lg font-semibold">{item.title}</h4>
												<p className="mt-1 text-sm leading-6 text-slate-300">{item.description}</p>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>

						<div className="rounded-[32px] border border-mineral-400/20 bg-gradient-to-br from-mineral-500/15 to-slate-900/70 p-6">
							<p className="text-sm uppercase tracking-[0.3em] text-mineral-200">Google Maps</p>
							<h3 className="mt-3 text-2xl font-semibold">Ubicacion integrada en la landing</h3>
							<p className="mt-3 text-slate-300">
								El mapa embebido ayuda a tus clientes a encontrar la empresa sin salir del sitio y mejora
								la confianza al momento de contactarte.
							</p>
						</div>
					</div>

					<div className="grid gap-6">
						<div className="glass rounded-[32px] p-6 shadow-2xl shadow-slate-950/30">
							<div className="mb-6 flex items-center gap-3">
								<div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold-400/15 text-gold-400">
									<Icons.Send />
								</div>
								<div>
									<h3 className="text-2xl font-semibold">Solicita informacion</h3>
									<p className="text-sm text-slate-300">Formulario mejorado para consultas comerciales y tecnicas.</p>
								</div>
							</div>

							{submitted ? (
								<div className="rounded-3xl border border-emerald-400/30 bg-emerald-500/15 p-6 text-emerald-100">
									<p className="text-lg font-semibold">Mensaje enviado con exito</p>
									<p className="mt-2 text-sm text-emerald-50/90">
										Recibimos tu solicitud y el equipo podra responderte en breve.
									</p>
								</div>
							) : (
								<form onSubmit={handleSubmit} className="grid gap-4 md:grid-cols-2">
									<label className="block">
										<span className="mb-2 block text-sm font-medium text-slate-200">Nombre completo</span>
										<input
											required
											placeholder="Tu nombre"
											className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none transition placeholder:text-slate-500 focus:border-mineral-400 focus:bg-white/10"
										/>
									</label>

									<label className="block">
										<span className="mb-2 block text-sm font-medium text-slate-200">Correo electronico</span>
										<input
											required
											type="email"
											placeholder="correo@empresa.com"
											className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none transition placeholder:text-slate-500 focus:border-mineral-400 focus:bg-white/10"
										/>
									</label>

									<label className="block">
										<span className="mb-2 block text-sm font-medium text-slate-200">Telefono</span>
										<input
											placeholder="Numero de contacto"
											className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none transition placeholder:text-slate-500 focus:border-mineral-400 focus:bg-white/10"
										/>
									</label>

									<label className="block">
										<span className="mb-2 block text-sm font-medium text-slate-200">Asunto</span>
										<input
											placeholder="Compra, venta, analisis o visita"
											className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none transition placeholder:text-slate-500 focus:border-mineral-400 focus:bg-white/10"
										/>
									</label>

									<label className="block md:col-span-2">
										<span className="mb-2 block text-sm font-medium text-slate-200">Mensaje</span>
										<textarea
											required
											rows="5"
											placeholder="Cuentanos que mineral, servicio o coordinacion necesitas."
											className="w-full rounded-3xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none transition placeholder:text-slate-500 focus:border-mineral-400 focus:bg-white/10"
										/>
									</label>

									<button
										type="submit"
										className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-mineral-500 to-gold-500 px-6 py-3 font-semibold text-slate-950 transition hover:scale-[1.01] hover:shadow-lg hover:shadow-mineral-500/20 md:col-span-2"
									>
										Enviar solicitud
										<Icons.ArrowRight />
									</button>
								</form>
							)}
						</div>

						<div className="overflow-hidden rounded-[32px] border border-white/10 bg-slate-900 shadow-2xl shadow-slate-950/30">
							<div className="flex items-center justify-between gap-4 border-b border-white/10 px-6 py-4">
								<div>
									<p className="text-sm uppercase tracking-[0.3em] text-slate-400">Mapa</p>
									<h3 className="mt-2 text-2xl font-semibold text-white">Ubicacion de la empresa</h3>
								</div>
								<div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-mineral-400/15 text-mineral-200">
									<Icons.MapPin />
								</div>
							</div>

							<div className="h-[420px] w-full">
								<iframe
									title="Mapa de Google Maps de la empresa"
									src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3758.623853659557!2d-65.75066792478128!3d-19.600609181714965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1ses!2sbo!4v1776962102154!5m2!1ses!2sbo"
									className="h-full w-full"
									style={{ border: 0 }}
									allowFullScreen
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
